module.exports = __webpack_public_path__ + "static/CircularStd-Book-d7083f6b50997e02f1c90d70bc3596e7.ttf";